var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPersonalGuidelinesBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 184,
    height: 119.386,
    viewBox: "0 0 184 119.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2285",
    "data-name": "Ret\\xE2ngulo 2285",
    width: 184,
    height: 119.386,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-personal-guidelines-black",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4982",
    "data-name": "Grupo 4982",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2336",
    "data-name": "Caminho 2336",
    d: "M79.484,96.6H16.033a28.919,28.919,0,0,1,1.9-9.059C18.987,84.7,19,84.707,21.989,84.707H36.407c3.022,0,3.39-.375,3.39-3.452V67.728l6.286-.966c.578,3.105,1.126,6.025,1.666,8.946.677,3.663,1.341,7.328,2.022,10.989a2.092,2.092,0,0,0,2.4,1.986q7.522.017,15.041,0c1.5,0,2.135-.583,2.417-2.109,1.155-6.227,2.319-12.45,3.451-18.68.119-.654.216-1.01,1.052-.963a30.537,30.537,0,0,1,17.949,7.361,3.547,3.547,0,0,1,4.309-1.483c-6.59-6.454-14.851-9.779-24.715-9.978-3.093-.064-6.186-.01-9.282-.01L56.462,62.8c-5.311.19-10.87.257-16.667.464,0-1.157.014-2.6,0-4.046-.019-1.626-.736-2.338-2.361-2.359-1.182-.017-2.365,0-3.6,0,0-1.836-.019-3.491.007-5.145.015-1.034-.039-2-1.1-2.57-1.077-.577-1.9.012-2.737.573-3.271,2.186-6.528,4.393-9.83,6.532a3.813,3.813,0,0,1-1.939.581c-5.138.047-10.277.025-15.413.028-2.214,0-2.81.591-2.81,2.783q0,11.129,0,22.257c0,2.213.594,2.813,2.78,2.814,3.932,0,7.863,0,11.937,0-.176.488-.307.868-.448,1.243a35.933,35.933,0,0,0-2.32,12.013c-.037,1.965.63,2.661,2.549,2.661q32.833,0,65.666,0a3.36,3.36,0,0,1-.69-4.022M69.223,66.859c-1.1,5.964-2.189,11.851-3.286,17.786H53.451l-3.3-17.786ZM4.091,80.707V60.83H5.351c4.39,0,8.781-.037,13.17.022a5.754,5.754,0,0,0,3.585-1.059c2.463-1.732,5-3.357,7.745-5.181,0,1.428-.012,2.64,0,3.854.021,1.623.733,2.337,2.356,2.359,1.153.017,2.305,0,3.531,0V80.707Z",
    transform: "translate(0.004 18.762)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2337",
    "data-name": "Caminho 2337",
    d: "M63.487,27.858c-1.344,0-2.538.019-3.732-.006a2,2,0,0,1-2.228-2.235q-.023-11.685,0-23.369A1.983,1.983,0,0,1,59.747.01q17.648-.019,35.3,0A1.991,1.991,0,0,1,97.3,2.217q.025,11.685,0,23.369c0,1.564-.783,2.266-2.449,2.269-5.261.008-10.522-.018-15.782.029a3.807,3.807,0,0,0-1.936.589c-3.369,2.183-6.7,4.428-10.033,6.665a2.117,2.117,0,0,1-3.617-1.894c.025-1.735.007-3.472.007-5.387M93.272,4.067H61.594V23.88c1.255,0,2.413-.015,3.57,0a2.036,2.036,0,0,1,2.3,2.3c.021,1.227,0,2.455,0,3.86.511-.309.859-.5,1.191-.722,2.171-1.445,4.367-2.853,6.5-4.359a5.693,5.693,0,0,1,3.57-1.1c4.015.069,8.035.025,12.052.025h2.5Z",
    transform: "translate(22.068 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2338",
    "data-name": "Caminho 2338",
    d: "M37.8,20.013c0,1.821-.014,3.6.006,5.371A2.219,2.219,0,0,1,36.735,27.6a2.169,2.169,0,0,1-2.43-.34c-3.368-2.261-6.729-4.534-10.13-6.744a3.794,3.794,0,0,0-1.934-.591c-6.5-.043-13.008-.024-19.511-.026C.621,19.9,0,19.275,0,17.155Q0,9.884,0,2.612C.005.66.661,0,2.611,0Q21.872,0,41.134,0c1.961,0,2.628.656,2.63,2.589q.008,7.333,0,14.667c0,1.963-.657,2.626-2.585,2.639-.993.007-1.987.007-2.982.015a2.456,2.456,0,0,0-.4.1M4.031,15.919c6.141,0,12.143.048,18.144-.032a6.821,6.821,0,0,1,4.262,1.3c2.35,1.667,4.782,3.218,7.143,4.793.136-.107.19-.129.191-.152.019-1.2.028-2.4.053-3.6a2.039,2.039,0,0,1,2.289-2.3c1.189-.019,2.379,0,3.6,0V4.062H4.031Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2264",
    "data-name": "Ret\\xE2ngulo 2264",
    width: 11.788,
    height: 3.827,
    transform: "translate(19.993 83.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2265",
    "data-name": "Ret\\xE2ngulo 2265",
    width: 7.844,
    height: 3.808,
    transform: "translate(8.018 83.647)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2266",
    "data-name": "Ret\\xE2ngulo 2266",
    width: 7.783,
    height: 3.87,
    transform: "translate(16.027 91.577)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2267",
    "data-name": "Ret\\xE2ngulo 2267",
    width: 3.802,
    height: 3.869,
    transform: "translate(8.071 91.618)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2268",
    "data-name": "Ret\\xE2ngulo 2268",
    width: 3.78,
    height: 3.869,
    transform: "translate(27.968 91.557)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2269",
    "data-name": "Ret\\xE2ngulo 2269",
    width: 11.768,
    height: 3.827,
    transform: "translate(87.618 16.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2270",
    "data-name": "Ret\\xE2ngulo 2270",
    width: 7.801,
    height: 3.823,
    transform: "translate(103.561 16.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2271",
    "data-name": "Ret\\xE2ngulo 2271",
    width: 7.823,
    height: 3.826,
    transform: "translate(95.58 8.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2272",
    "data-name": "Ret\\xE2ngulo 2272",
    width: 3.867,
    height: 3.802,
    transform: "translate(107.482 8.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2273",
    "data-name": "Ret\\xE2ngulo 2273",
    width: 3.838,
    height: 3.818,
    transform: "translate(87.626 8.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2274",
    "data-name": "Ret\\xE2ngulo 2274",
    width: 7.801,
    height: 3.827,
    transform: "translate(19.951 8.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2275",
    "data-name": "Ret\\xE2ngulo 2275",
    width: 7.801,
    height: 3.829,
    transform: "translate(8.07 8.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2276",
    "data-name": "Ret\\xE2ngulo 2276",
    width: 3.816,
    height: 3.838,
    transform: "translate(31.901 8.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2339",
    "data-name": "Caminho 2339",
    d: "M61.246,72.072a19.078,19.078,0,0,0,8.728-13.308,1.357,1.357,0,0,1,.652-.91c3.129-1.306,4.068-2.693,4.068-6.117q-.012-5.025-.012-10.048c-.007-3.791.019-7.584-.007-11.375a6.238,6.238,0,0,0-5.691-6.661h-.012A1.193,1.193,0,0,1,67.8,22.438a6.211,6.211,0,0,0-6.383-5.7c-6.593-.029-13.187-.051-19.778.011A15.821,15.821,0,0,0,26.172,29.962a78.98,78.98,0,0,0-.321,9.927c-.039,1.7.262,3.436-.928,4.934a2.193,2.193,0,0,0-.343,1.229c-.069,1.936-.206,3.878-.093,5.806a6.365,6.365,0,0,0,5.1,6.052A1.141,1.141,0,0,1,30.6,58.972a18.653,18.653,0,0,0,7.266,12.1,36.569,36.569,0,0,0,4.624,2.723,20.442,20.442,0,0,0,14.18.483,28.706,28.706,0,0,0,4.572-2.2M29.785,31.688A12.045,12.045,0,0,1,41.2,20.661c6.722-.134,13.449-.057,20.173-.043.046,0,.09-.006.136-.007a2.4,2.4,0,0,1,2.451,2.337c.446,2.927,1.54,4.042,4.431,4.511,1.717.278,2.392,1.071,2.4,2.939.018,3.706,0,7.414.008,11.121,0,.854-.033,1.681-1.045,1.979a2.15,2.15,0,0,1-2.477-.926c-.154-.2-.268-.437-.416-.652a3.929,3.929,0,0,0-4.255-1.81c-6.779,1.523-12.16-.956-16.752-5.723A7.327,7.327,0,0,0,41.021,31.7a6.137,6.137,0,0,0-.764-.036,6.351,6.351,0,0,0-6.279,6.423c-.048,2.1-.01,4.211-.01,6.555h0a23.246,23.246,0,0,1-3.241-1.164,2.049,2.049,0,0,1-.963-1.451c-.072-3.448-.156-6.9.025-10.343m40.979,21.1c-.029.852-.635,1.218-1.5,1.269-2.571.154-2.867.466-3.015,2.962-.477,8.064-7.994,14.68-16.344,14.39A15.813,15.813,0,0,1,34.2,56.454c-.126-1.622-.733-2.185-2.373-2.217-2.571-.048-3.5-.973-3.527-3.51-.008-1.243,0-2.486,0-3.93,1.624.56,3.026,1.078,4.45,1.523a3.747,3.747,0,0,0,5.086-3.614c.053-2.066.021-4.134.008-6.2a2.568,2.568,0,0,1,1.539-2.727,2.73,2.73,0,0,1,3.249.855,23.589,23.589,0,0,0,11.391,7.238,19.419,19.419,0,0,0,8.58.213,1.426,1.426,0,0,1,1.184.285,6.41,6.41,0,0,0,7,2.96c0,1.868.048,3.667-.021,5.46",
    transform: "translate(9.379 6.409)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2340",
    "data-name": "Caminho 2340",
    d: "M22.049,84.69H36.467c3.022,0,3.39-.374,3.39-3.452V63.245c0-1.158.014-2.6,0-4.047-.019-1.626-.736-2.338-2.361-2.359-1.182-.017-2.365,0-3.6,0,0-1.836-.019-3.491.007-5.145.015-1.034-.039-2-1.1-2.568-1.077-.577-1.9.011-2.737.571-3.271,2.188-6.528,4.393-9.83,6.532a3.814,3.814,0,0,1-1.939.583c-5.138.046-10.277.024-15.413.026-2.214,0-2.81.591-2.81,2.783q0,11.129,0,22.257c0,2.214.594,2.814,2.78,2.816,3.932,0,7.863,0,11.937,0Zm-17.9-4V60.814H5.411c4.39,0,8.781-.037,13.17.022a5.754,5.754,0,0,0,3.585-1.059c2.463-1.732,5-3.357,7.744-5.181,0,1.428-.012,2.64,0,3.854.021,1.623.733,2.337,2.356,2.359,1.153.017,2.305,0,3.531,0V80.69Z",
    transform: "translate(0.027 18.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2277",
    "data-name": "Ret\\xE2ngulo 2277",
    width: 11.788,
    height: 3.827,
    transform: "translate(20.076 83.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2278",
    "data-name": "Ret\\xE2ngulo 2278",
    width: 7.844,
    height: 3.808,
    transform: "translate(8.101 83.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2279",
    "data-name": "Ret\\xE2ngulo 2279",
    width: 7.783,
    height: 3.87,
    transform: "translate(16.11 91.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2280",
    "data-name": "Ret\\xE2ngulo 2280",
    width: 3.802,
    height: 3.869,
    transform: "translate(8.154 91.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2281",
    "data-name": "Ret\\xE2ngulo 2281",
    width: 3.78,
    height: 3.869,
    transform: "translate(28.052 91.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2341",
    "data-name": "Caminho 2341",
    d: "M133.876,89.522c-6.265-8.724-14.839-13.177-25.582-13.394-2.7-.055-5.4-.008-8.1-.008q12.8-2.74,15.006-15.578c2.571-.274,4.545-1.465,5-4.069.66-3.757.224-5.787-3.052-7.917,3.1-1.652,3.4-4.3,3.307-7.349a15.772,15.772,0,0,0-15.483-15.445q-7.161-.064-14.323,0A15.416,15.416,0,0,0,75.71,37.933a33.344,33.344,0,0,0-.4,6.469,3.514,3.514,0,0,0,.823,1.99,24.256,24.256,0,0,0,2.3,2.264c-3.281,2.033-3.544,4.2-3.012,7.643.419,2.7,2.419,3.97,5.062,4.247,1.478,8.591,6.5,13.736,14.656,15.435l-9.619.343a2.3,2.3,0,0,1-.037.423,1.522,1.522,0,0,1-.206.762,2.311,2.311,0,0,1-.234.494,3.146,3.146,0,0,1,.34.441c.1.241.2.482.3.721a3.018,3.018,0,0,1,.057.428l.219-.033c.5,2.711.982,5.258,1.454,7.808.589,3.2,1.169,6.4,1.764,9.592a1.825,1.825,0,0,0,2.094,1.734q6.565.015,13.128,0c1.309,0,1.864-.508,2.11-1.84,1.009-5.434,2.024-10.866,3.012-16.3.1-.571.188-.881.917-.84,13.387.746,24.915,12.394,25.5,25.9H59.728a25.257,25.257,0,0,1,1.66-7.906c.082-.219.148-.4.219-.577-1.222-.024-2.444-.028-3.664-.035a31.2,31.2,0,0,0-1.771,9.707c-.032,1.716.551,2.322,2.225,2.322q39.441,0,78.884,0c1.63,0,2.248-.613,2.217-2.222a30.141,30.141,0,0,0-5.622-17.371M115.285,56.978V51.839a1.687,1.687,0,0,1,1.647,1.77c.16,2.374-.113,2.956-1.647,3.369m-34.87-.029c-1.265-.246-1.652-.718-1.68-1.984-.051-2.341.163-2.758,1.68-3.119Zm.1-11.316c-1.979-.85-1.82-2.435-1.784-4,.119-5.181,2.426-9.037,7.115-11.234a13.139,13.139,0,0,1,5.017-1.118c4.626-.148,9.258-.084,13.888-.043a12.149,12.149,0,0,1,12.186,12.116,6.834,6.834,0,0,0,.014,1.191c.285,1.481-.553,2.33-1.774,3.212.324-2.091-.971-2.524-2.492-2.925Q104.2,40.589,95.755,38.2a4.168,4.168,0,0,0-3.018.238q-5.147,2.289-10.356,4.442c-1.272.523-2.175,1.171-1.871,2.755m3.635,15.356a17.552,17.552,0,0,1-.194-2.482c-.019-4.157-.008-8.313-.008-12.5,3.39-1.453,6.736-2.9,10.1-4.307a1.74,1.74,0,0,1,1.046-.051q8.1,2.19,16.191,4.422a1.444,1.444,0,0,1,.255.1c0,4.99.365,9.935-.09,14.8-.62,6.618-6.8,11.651-13.549,11.67A13.909,13.909,0,0,1,84.146,60.989m19.142,34.18H92.39L89.511,79.644h16.647c-.963,5.205-1.912,10.344-2.87,15.525",
    transform: "translate(21.552 10.269)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2342",
    "data-name": "Caminho 2342",
    d: "M137.707,83.118c-1.222.008-2.444.012-3.665.036.071.181.137.358.219.577a25.218,25.218,0,0,1,1.66,7.906H59.712c.584-13.5,12.111-25.151,25.5-25.9.729-.04.814.27.917.841.988,5.438,2,10.87,3.012,16.3.246,1.333.8,1.838,2.11,1.84q6.563.017,13.128,0a1.823,1.823,0,0,0,2.094-1.732c.6-3.2,1.175-6.4,1.764-9.592.451-2.439.91-4.884,1.391-7.464a3.685,3.685,0,0,1-.682-.785,2.914,2.914,0,0,1-.353-2.009,2.745,2.745,0,0,1-.459.054c-4.659-.007-9.321-.372-13.975,0a2.787,2.787,0,0,1-2.271-1.06c-1.511-.007-3.022-.008-4.533.024-10.742.217-19.315,4.67-25.58,13.394a30.141,30.141,0,0,0-5.622,17.369c-.032,1.611.587,2.224,2.217,2.224q39.441,0,78.884,0c1.674,0,2.257-.606,2.225-2.322a31.256,31.256,0,0,0-1.77-9.708M106.138,65.677,103.259,81.2h-10.9c-.958-5.181-1.907-10.32-2.868-15.525Z",
    transform: "translate(21.544 24.236)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2343",
    "data-name": "Caminho 2343",
    d: "M106.918,35.58c-.995-.007-1.988-.008-2.982-.015-1.927-.012-2.583-.675-2.585-2.637q-.008-7.335,0-14.668c0-1.932.67-2.587,2.63-2.589q19.261,0,38.523,0c1.95,0,2.605.659,2.607,2.61q.008,7.273,0,14.544c0,2.12-.618,2.74-2.727,2.741-6.5,0-13.008-.015-19.511.028a3.792,3.792,0,0,0-1.934.589c-3.4,2.211-6.762,4.483-10.13,6.745a2.174,2.174,0,0,1-2.43.34,2.219,2.219,0,0,1-1.068-2.214c.019-1.775.006-3.551.006-5.373a2.626,2.626,0,0,0-.4-.1m34.167-15.85H105.4V31.589c1.222,0,2.412-.017,3.6,0a2.038,2.038,0,0,1,2.289,2.3c.025,1.2.033,2.4.053,3.6,0,.024.055.047.191.154,2.362-1.576,4.793-3.126,7.143-4.793a6.814,6.814,0,0,1,4.262-1.3c6,.08,12,.032,18.144.032Z",
    transform: "translate(38.886 6.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2282",
    "data-name": "Ret\\xE2ngulo 2282",
    width: 7.801,
    height: 3.827,
    transform: "translate(156.249 29.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2283",
    "data-name": "Ret\\xE2ngulo 2283",
    width: 7.801,
    height: 3.829,
    transform: "translate(168.129 29.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2284",
    "data-name": "Ret\\xE2ngulo 2284",
    width: 3.816,
    height: 3.838,
    transform: "translate(148.284 29.698)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonalGuidelinesBlack);
export default __webpack_public_path__ + "static/media/icon-personal-guidelines-black.823e811bb071d77720fc8c4ae0796de3.svg";
export { ForwardRef as ReactComponent };